module.exports = __webpack_public_path__ + "f06a98cd5c0b07d6c3d0d7cc2f6a40b8.svg";